<template>
  <div class="mod-rm__vehicleinfo">
    <div class="pkg-search-box">
      <el-form class="pkg-content"
               :inline="false"
               :model="dataForm"
               ref="vehicleInfoRef"
               @submit.native.prevent
               @keyup.enter.native="queryDataInfo()"
               label-width="90px">
        <!--查询条件 第一行-->
        <el-row :gutter="0">
          <!--车辆底盘号-->
          <el-col :span="7">
            <el-form-item prop="chassisNo"
                          class="courseclassroomrela"
                          :label="$t('res.vehinfo.chassisNo')">
              <el-input v-model="dataForm.chassisNo"
                        :placeholder="$t('res.vehinfo.input')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!--车型分类-->
          <el-col :span="7">
            <el-form-item prop="vehicleClassList"
                          :label="$t('res.vehinfo.vehicleClassId')"
                          class="courseclassroomrela">
              <class-tree ref="classRef"
                          v-on:getSelectList="getSelectList"
                          v-bind:defaultProps="defaultProps"
                          v-bind:url="queryTreeUrl"
                          v-on:clearTreeInfo="classRef"
                          v-bind:isSelect=false
                          v-bind:status="'classStatus'"></class-tree>
            </el-form-item>
          </el-col>
          <!--车辆标签-->
          <el-col :span="7">
            <!--<el-form-item prop="label"-->
                          <!--:label="$t('res.vehinfo.label')">-->
              <!--<el-input v-model="dataForm.labelTypeName"-->
                        <!--@focus="showSuboLableDlg()"-->
                        <!--:placeholder="$t('trainer.Label')"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item class="courseclassroomrela1" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                           @click.native.prevent="showSuboLableDlg">{{ $t('res.vehinfo.label')}}</el-link>
                </span>
              <div class="el-input el-input--default el-input__inner el-form-item__content" style="height:30px;" @mouseenter="vehicleLabelShow()" @mouseleave="vehicleLabelLeave()" >
                <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeName}}</div>
                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="vehicleLabelShowFlg && dataForm.labelTypeName != '' && dataForm.labelTypeName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="vehicleLabelName()"></el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="3"
                  class="query-button">
            <!-- 查询按钮 -->
            <el-col :span="24">
              <!--查询按钮-->
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         v-if="$hasPermission('AUTHVEHICLE0001')"
                         @click="queryDataInfo()">{{ $t('query') }}</el-button>
              <!-- <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataList">{{$t('user.query')}}</el-button> -->
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第二行-->
        <el-row :gutter="0">
          <!--车辆分类-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.vehicleClassification')" class="courseclassroomrela">
              <el-select multiple
                         collapse-tags
                         v-model="dataForm.vehicleClassificationList"
                         :placeholder="$t('res.vehinfo.select')"
                         clearable>
                <el-option v-for="(item,index) in vehicleClassArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--所属公司-->
          <el-col :span="7">
            <el-form-item :label="$t('res.vehinfo.companyId')" class="courseclassroomrela">
              <el-select clearable
                         multiple
                         collapse-tags
                         filterable
                         remote
                         reserve-keyword
                         v-model="dataForm.companyIdList">
                <el-option v-for="item in companyList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--所属场地-->
          <el-col :span="7">
            <!--<el-form-item :label="$t('res.vehinfo.subordinateSiteId')">-->
              <!--<el-input v-model="dataForm.subordinateSiteName"-->
                        <!--@focus="showSuboSiteDlg()"-->
                        <!--:placeholder="$t('res.vehinfo.select')"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item class="courseclassroomrela1" style="height: 34px;">
                <span slot="label">
                  <el-link type="primary" :underline="false" slot="reference"
                           @click.native.prevent="showSuboSiteDlg">{{ $t('res.vehinfo.subordinateSiteId')}}</el-link>
                </span>
              <div class="el-input el-input--default el-input__inner el-form-item__content" style="height:30px;" @mouseenter="siteSeleteShow()" @mouseleave="siteSeleteLeave()" >
                <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.subordinateSiteName}}</div>
                <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="siteNameLink" v-show="siteSeleteShowFlg && dataForm.subordinateSiteName != '' && dataForm.subordinateSiteName != null" style="float:right;margin-top:0px;color:rgba(0,0,0,.3);" @click="siteSeleteName()"></el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="3"
                  class="query-button">
            <!-- 重置按钮 -->
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         v-if="$hasPermission('AUTHVEHICLE0002')"
                         @click="resetQuery">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!--查询条件 第三行-->
        <div v-show="moreList">
          <el-row :gutter="0">
            <!--当前场地-->
            <el-col :span="7">
              <el-form-item prop="presentSiteName"
                            :label="$t('res.vehinfo.presentSiteId')" class="courseclassroomrela">
                <el-input v-model="dataForm.presentSiteName"
                          :placeholder="$t('res.vehinfo.input')"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <!--车辆状态-->
            <el-col :span="7">
              <el-form-item :label="$t('res.vehinfo.status')" class="courseclassroomrela">
                <el-select multiple
                           collapse-tags
                           v-model="dataForm.statusList"
                           :placeholder="$t('res.vehinfo.select')"
                           clearable>
                  <el-option v-for="(item,index) in statusArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--是否有车辆配置信息-->
            <el-col :span="7">
              <el-form-item :label="$t('res.vehinfo.isUpload')" label-width="100px" class="courseclassroomrela">
                <el-select multiple
                           collapse-tags
                           v-model="dataForm.isUploadList"
                           :placeholder="$t('res.vehinfo.select')"
                           clearable>
                  <el-option v-for="(item,index) in isUploadList"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <!-- 展开or收起 -->
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon"
               v-bind:class="{ 'el-icon-arrow-up': moreList,
                                       'el-icon-arrow-down': !moreList }"
               @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <!--按钮区-->
      <div class="search">
        <!--新增-->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0003')"
                   @click="addUpdate('add')">{{ $t('add') }}</el-button>
        <!-- 导出 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0004')"
                   @click="exportHandle()">{{ $t('export') }}</el-button>
        <!-- 年度目标模板导出 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0005')"
                   @click="exportAnnualTarget">{{ $t('res.cri.ATTemplateExport') }}</el-button>
        <!-- 年度目标导入 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0006')"
                   @click="importAnnualTarget()">{{ $t('res.cri.ATargetImport') }}</el-button>
        <!-- 车辆信息模板导出 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0007')"
                   @click="exportVehicleInfo">{{ $t('res.vehinfo.ATTemplateExport') }}
        </el-button>
        <!-- 车辆信息导入 -->
        <el-button type="primary"
                   v-if="$hasPermission('AUTHVEHICLE0008')"
                   @click="importVehicleDialog()">{{ $t('res.vehinfo.ATargetImport') }}</el-button>
      </div>

      <el-table :data="dataList"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
        <!-- 序号 -->
        <el-table-column type="index"
                         header-align="center"
                         align="center"
                         width="50"
                         :index="indexCreate"
                         :label="$t('res.vehinfo.serialNo')">
        </el-table-column>
        <!--车辆底盘号-->
        <el-table-column prop="chassisNo"
                         header-align="center"
                         align="center"
                         width="100"
                         show-overflow-tooltip
                         :label="$t('res.vehinfo.chassisNo')">
        </el-table-column>
        <!--车型分类-->
        <el-table-column prop="classCnName"
                         header-align="center"
                         show-overflow-tooltip
                         align="center"
                         :label="$t('res.vehinfo.vehicleClassId')">
        </el-table-column>
        <!--所属公司-->
        <el-table-column prop="companyCnName"
                         header-align="center"
                         show-overflow-tooltip
                         align="center"
                         :label="$t('res.vehinfo.companyId')">
        </el-table-column>
        <!--所属场地-->
        <el-table-column prop="siteCnName"
                         show-overflow-tooltip
                         header-align="center"
                         align="center"
                         :label="$t('res.vehinfo.subordinateSiteId')">
        </el-table-column>
        <!--当前场地-->
        <el-table-column prop="presentSiteName"
                         show-overflow-tooltip
                         header-align="center"
                         align="center"
                         :label="$t('res.vehinfo.presentSiteId')">
        </el-table-column>
        <!--车辆分类-->
        <el-table-column prop="vehicleClassification"
                         :formatter="vehicleClassFormatter"
                         header-align="center"
                         align="center"
                         :label="$t('res.vehinfo.vehicleClassification')">
        </el-table-column>
        <!--车辆标签-->
        <el-table-column header-align="center"
                         align="center"
                         :label="$t('res.vehinfo.label')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  v-if="scope.row.number !== null"
                  @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
          </template>
        </el-table-column>
        <!--车辆状态-->
        <el-table-column prop="status"
                         :formatter="statusFormatter"
                         header-align="center"
                         align="center"
                         :label="$t('res.vehinfo.status')">
        </el-table-column>
        <!--是否有车辆配置信息-->
        <el-table-column prop="isUpload"
                         header-align="center"
                         align="center"
                         width="150"
                         show-overflow-tooltip
                         :label="$t('res.vehinfo.isUpload')">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isUpload === '10'"
                       size="mini"
                       type="text"
                       @click="downloadFile(scope.row)">{{ $t('res.vehinfo.yes') }}</el-button>
            <div v-if="scope.row.isUpload === '20'">{{ $t('res.vehinfo.no') }}</div>
          </template>
        </el-table-column>

        <el-table-column fixed="right"
                         align="center"
                         width="120"
                         v-if="$hasPermission('AUTHVEHICLE0009') || $hasPermission('AUTHVEHICLE0010') || $hasPermission('AUTHVEHICLE0011') || $hasPermission('AUTHVEHICLE0012') || $hasPermission('AUTHVEHICLE0013')"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <!--查看-->
            <span class="el-dropdown-link"
                  v-if="$hasPermission('AUTHVEHICLE0009')"
                  @click="gotoView('check', scope.row)">{{ $t('res.vehinfo.check') }}</span>
            <div class="pkg-vertical-divider"
                 v-if="$hasPermission('AUTHVEHICLE0009') || ($hasPermission('AUTHVEHICLE0010') && $hasPermission('AUTHVEHICLE0011') && $hasPermission('AUTHVEHICLE0012') && $hasPermission('AUTHVEHICLE0013'))"></div>
            <el-dropdown trigger="click"
                         v-if="$hasPermission('AUTHVEHICLE0010') || $hasPermission('AUTHVEHICLE0011') || $hasPermission('AUTHVEHICLE0012') || $hasPermission('AUTHVEHICLE0013')"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!--查看-->
                <!--<el-dropdown-item v-if="$hasPermission('AUTHVEHICLE0009')" @click.native="gotoView('check', scope.row)">{{ $t('res.vehinfo.check') }}</el-dropdown-item>-->
                <!--编辑-->
                <el-dropdown-item v-if="$hasPermission('AUTHVEHICLE0010')" @click.native="gotoView('update', scope.row)">{{ $t('res.vehinfo.edit') }}</el-dropdown-item>
                <!--显示不活动按钮-->
                <el-dropdown-item v-if="scope.row.status =='10' && $hasPermission('AUTHVEHICLE0011')"
                                  @click.native="gotoView('noActivity', scope.row)">{{ $t('res.vehinfo.unInactive') }}</el-dropdown-item>
                <!--显示活动按钮-->
                <el-dropdown-item v-if="scope.row.status =='20' && $hasPermission('AUTHVEHICLE0012')"
                                  @click.native="gotoView('activity', scope.row)">{{ $t('res.vehinfo.inactive') }}</el-dropdown-item>
                <!--日历-->
                <!--<el-dropdown-item disabled>{{ $t('res.vehinfo.calendar') }}</el-dropdown-item>-->
                <!--替换车辆-->
                <el-dropdown-item v-if="$hasPermission('AUTHVEHICLE0013')" @click.native="replace(scope.row)">{{ $t('res.vehinfo.replaceVeh') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="dataForm.page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="dataForm.limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <!--年度目标导入-->
    <import-excel v-bind:visible="importDialog"
                  v-bind:url="importUrl"
                  v-on:closeDialogImport="closeDialogImport"></import-excel>
    <!--车辆信息导入-->
    <import-excel v-bind:visible="importVehicleInfo"
                  v-bind:url="importVehicleUrl"
                  v-on:closeDialogImport="closeDialogImport"></import-excel>
    <!-- 所属场地dialog -->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='false'
                      :isShow='true'
                      :isQueryShow="false"
                      v-bind:selectTable="selectTable"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
    <!--车辆替换弹窗-->
    <el-dialog :title="$t('res.vehinfo.replace')"
               :visible.sync="isShowEditForm"
               top="100px"
               width="500">
      <!--:rules="dataRule"-->
      <el-form :model="dataReplace"
               label-width="125px"
               label-position="right"
               ref="dataForm">
        <div class="location-layout">
          <el-row :gutter="10">
            <!--被替换车辆-->
            <el-col :span="20">
              <el-form-item :label="$t('res.vehinfo.replaceCar')"
                            prop="chassisNo">
                <el-input v-model="dataReplace.chassisNo"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <br>
          <br>
          <el-row :gutter="10">
            <!--替换新车辆-->
            <el-col :span="20"
                    style="margin-bottom: 10px">
              <el-form-item :label="$t('res.vehinfo.replaceNewCar')"
                            prop="newVin">
                <!--<el-input v-model="dataForm.newVin"></el-input>-->
                <el-select collapse-tags
                           filterable
                           remote
                           reserve-keyword
                           v-model="dataReplace.newVin"
                           :placeholder="$t('res.vehinfo.select')"
                           clearable>
                  <el-option v-for="(item,index) in chassisNoList"
                             :key="index"
                             :label="item.chassisNo"
                             :value="item.chassisNo">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="1"
                  style="margin-bottom: 10px">
            <!--开始时间-->
            <el-col :span="13">
              <el-form-item :label="$t('res.vehinfo.startDate')"
                            prop="startTime">
                <el-date-picker type="date"
                                value-format="yyyy-MM-dd"
                                v-model="dataReplace.startTime"
                                :placeholder="$t('res.vehinfo.startDate')">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8">-->
              <!--<el-form-item label-width="0">-->
                <!--<span slot="label"></span>-->
                <!--<el-select type="date"-->
                           <!--format="yyyy-MM-dd"-->
                           <!--v-model="dataReplace.startDateAm">-->
                <!--</el-select>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          </el-row>
          <el-row :gutter="1">
            <!--结束时间-->
            <el-col :span="13">
              <el-form-item :label="$t('res.vehinfo.endDate')"
                            prop="endTime">
                <el-date-picker type="date"
                                value-format="yyyy-MM-dd"
                                v-model="dataReplace.endTime"
                                :placeholder="$t('res.vehinfo.endDate')">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8">-->
              <!--<el-form-item label-width="0">-->
                <!--<span slot="label"></span>-->
                <!--<el-select type="date"-->
                           <!--format="yyyy-MM-dd"-->
                           <!--v-model="dataReplace.startDatePm">-->
                <!--</el-select>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          </el-row>
          <el-row>
            <el-col :span="24"
                    align="right">
              <!-- 保存 -->
              <el-button type="primary"
                         @click="replacemenSave()">{{ $t('res.vehinfo.save') }}</el-button>
              <!-- 返回 -->
              <el-button type="primary"
                         @click="replacemenClose()">{{ $t('res.vehinfo.back') }}</el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
               :visible="isShowLable"
               width="70%"
               :before-close="showLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkLists"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTrees'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
               :visible="isQueryShowLable"
               width="70%"
               :before-close="showQueryLableClose">
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "true"
                     :closeShow = "true"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary"
                   @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
import ClassTree from '@/components/rm/class-tree/index'
import subordinateSite from '@/components/rm/resources-site/index'
import importExcel from '@/components/rm/import-excel/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'

export default {
  // mixins: [mixinViewModule],
  components: {
    Tag,
    'class-tree': ClassTree,
    'subordinate-site': subordinateSite,
    'import-excel': importExcel
  },
  data () {
    let _this = this
    return {
      checkLists:[],
      // mixinViewModuleOptions: {
      //   getDataListURL: '/rm/vehicleinfo/list',
      //   getDataListIsPage: true,
      //   deleteURL: '/rm/vehicleinfo/delete',
      //   deleteIsBatch: true,
      //   exportURL: '/rm/vehicleinfo/export'
      // },
      dataForm: {
        startDatePm: '',
        startDateAm: '',
        startDate: '',
        endDate: '',
        chassisNo: '',
        vehicleClassList: [],
        isUploadList: [],
        vehicleClassificationList: [],
        label: [],
        labelTypeName: '',
        vehicleClassification: '',
        companyIdList: [],
        subordinateSiteIdList: [],
        subordinateSiteName: '',
        presentSiteName: '',
        statusList: [],
        key: '',
        page: 1,
        limit: 10
      },
      total:0,
      dataReplace: {
        chassisNo:'',
        newVin: '',
        startTime: '',
        endTime: ''
      },
      // dataRule: {
      //   newVin: [
      //     { required: true, message: this.$t('validate.required'), trigger: 'blur' }
      //   ],
      //   startDate: [
      //     { required: true, message: this.$t('validate.required'), trigger: 'change' }
      //   ]
      // },
      vehicleLabelShowFlg: false,
      siteSeleteShowFlg: false,
      // 替换车辆下拉选数据
      chassisNoList: [],
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 16,
      bussinessTypeChecked: 16,
      selectTable: [],
      siteList: [], // 所属场地
      companyList: [], // 所属公司
      // 默认收起多的查询条件
      moreList: false,
      deleteList: false,
      isShowEditForm: false,
      statusArr: _this.enums['status'], // 车辆状态
      labelList: [], // 标签
      isUploadList: _this.enums['confirmState'], // 是否配置车辆信息
      vehicleClassArr: _this.enums['vehicleClass'], // 车型分类
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      dataListLoading: false,
      dataListSelections: [],
      // 车型分类树
      defaultProps: {
        children: 'children',
        label: 'classCnName'
      },
      queryTreeUrl: '/rm/vehicleclass/list',
      // 是否显示所属场地
      isShowSuboSite: false,
      // 导入年度目标
      importDialog: false,
      // 导入车辆信息
      importVehicleInfo: false,
      // 导入年度目标接口路径
      importUrl: '/rm/vehicleinfo/importAnnualTarget',
      // 导入车辆信息接口路径
      importVehicleUrl: '/rm/vehicleinfo/importVehicleInfo'
    }
  },
  watch: {
    // 监听所属场地名称
    'dataForm.subordinateSiteName': function (newValue, oldValue) {
      if (!newValue || newValue === '') {
        // 清空所属场地
        this.dataForm.subordinateSiteIdList = []
      }
    }
  },
  activated () {
    this.getInfo()
    // 获取公司下拉框数据
    this.$request.get(`/rm/company/info`, { 'orgTypeList': '10,20,30,40,50' }).then((data) => {
      let arr = []
      data.forEach(function (item) {
        let param = { value: item.orgId, label: item.nameCn }
        arr.push(param)
      })
      this.companyList = arr
    })
  },
  methods: {
    // 查询按钮
    queryDataInfo () {
      this.dataForm.page = 1
      this.getInfo()
    },
    // 查询
    getInfo () {
      this.dataListLoading = true
      this.$request.post('/rm/vehicleinfo/postList', this.dataForm).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.data.records
        this.dataList = resultList
        this.total = parseInt(data.data.total, 10)
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    classRef (){ 
      this.dataForm.vehicleClassList = []
    },
    // 下载文件
    downloadFile (row) {
      // this.$confirm(this.$t('prompt.info', { 'handle': this.$t('res.vehinfo.download') }), this.$t('prompt.title'), {
        this.$confirm(this.$t('res.vehinfo.download'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/rm/file/download' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
        let dlform = document.createElement('form')
        dlform.method = 'post'
        dlform.action = requestUrl
        let hdnFilePath = document.createElement('input')
        hdnFilePath.type = 'hidden'
        hdnFilePath.name = 'id'
        hdnFilePath.value = row.fileId
        dlform.appendChild(hdnFilePath)
        document.body.appendChild(dlform)
        dlform.submit()
        document.body.removeChild(dlform)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose(){
      this.isQueryShowLable = false
    },
    onOkLable(){
      console.info('132564')
      console.info(this.checkList)
      console.info('56465879')
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let vehicleLabelinfo = []
        let vehicleLabelinfoName = []
        args.forEach(function (item) {
          vehicleLabelinfo.push(item.labelId)
          vehicleLabelinfoName.push(item.labelName)
        })
        this.dataForm.label = vehicleLabelinfo
        this.dataForm.labelTypeName = vehicleLabelinfoName.join(',')
        console.info(this.dataForm.label)
        console.info(this.dataForm.labelTypeName)
      } else {
        this.dataForm.label = []
        this.dataForm.labelTypeName = ''
      }
      this.isQueryShowLable = false
    },
    // 重置查询条件
    resetQuery () {
      // this.reset()
      this.dataForm = {
          startDatePm: '',
          startDateAm: '',
          startDate: '',
          endDate: '',
          chassisNo: '',
          vehicleClassList: [],
          isUploadList: [],
          vehicleClassificationList: [],
          label: [],
          labelTypeName: '',
          vehicleClassification: '',
          companyIdList: [],
          subordinateSiteIdList: [],
          subordinateSiteName: '',
          presentSiteName: '',
          statusList: [],
          key: '',
          page: 1,
          limit: 10
      },
      // 重置清空主键中的数据
      this.selectTable = []
      this.$refs.classRef.resetChecked()
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.$refs.tagTree && this.$refs.tagTree.isReset()
      // 刷新视图
      this.$forceUpdate()
      this.getInfo()
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 是否有车辆配置信息转换
    isUploadFormatter (row) {
      return Vue.filter('coverEnum')(row.isUpload, 'confirmState')
    },
    // 车辆分类转换
    vehicleClassFormatter (row) {
      return Vue.filter('coverEnum')(row.vehicleClassification, 'vehicleClass')
    },
    // // 展开or收起
    // showOrHideMoreList () {
    //   this.moreList = !this.moreList
    // },
    // 替换车辆弹窗
    replace (row) {
      this.dataReplace = []
      this.dataReplace.chassisNo = row.chassisNo
      this.$request.get(`/rm/vehicleinfo/queryChassisNoList`, { chassisNo: row.chassisNo }).then((res, total, code, data) => {
        console.info('123')
        console.info(data)
        console.info('456')
        this.chassisNoList = data.data;
      })
      this.isShowEditForm = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    replacemenSave(){
      let _this = this
      if(_this.dataReplace.newVin === null || _this.dataReplace.newVin === '' || _this.dataReplace.newVin === undefined){
        _this.$message.warning(_this.$t('vehicle.newVin'))
        return false
      }
      if(_this.dataReplace.startTime === null || _this.dataReplace.startTime === '' || _this.dataReplace.startTime === undefined){
        _this.$message.warning(_this.$t('vehicle.download'))
        return false
      }
      let url = ''
      let param = ''
      url = '/rm/vehicleinfo/replace'
      param = {
        ...this.dataReplace,
      }
      _this.$request.post(
              url, param
      ).then((data) => {
        _this.$message({
          message: _this.$t('prompt.success'),
          type: 'success',
          duration: 500,
        })
        this.isShowEditForm = false
      })
    },
    // 关闭替换车辆弹窗
    replacemenClose () {
      this.isShowEditForm = false
    },
    again () {
      this.dataForm = []
    },
    // 批量导出
    exportHandle () {
      // // download 参数 url, params, 报表名
      // this.$request.downloadRm('/rm/vehicleinfo/export', this.$t('res.vehinfo.export'),
      //   {
      //     ...this.dataForm,
      //     page: this.page,
      //     limit: this.limit
      //   }
      // )
      this.$request.downloadByPost7(
              "/rm/vehicleinfo/export",
              this.$t('res.vehinfo.export') + '.xls',
              this.dataForm, null, "xls"
      )
    },
    // 操作区下拉的方法
    gotoView (type, row) {
      let query = {}
      let name = 'rm-vehicleinfo-add-or-update'
      query.id = row.id
      if (type === 'check') {
        name = 'rm-vehicleinfo-check'
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.VEHICLE_INFO, '')
      } else if (type === 'update') {
        query.type = 'updata'
        query.operationType = 'update'
        this.$router.push({
          name: name,
          query: query
        })
        // 广播通知执行初始化方法
        this.$eventHub.$emit(this.GLOBAL.VEHICLE_INFO, '')
      } else if (type === 'activity') {
        this.modify(type, row)
      } else if (type === 'noActivity') {
        this.modify(type, row)
      }
    },
    // 修改活动/不活动
    modify (type, row) {
      let tips
      if (type === 'activity') {
        tips = this.$t('res.vehinfo.vehicleActivityStatus')
      } else if (type === 'noActivity') {
        tips = this.$t('res.vehinfo.vehicleInactiveStatus')
      }
      this.$confirm(tips, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        row['statusType'] = type
        this.$request.post(
          `/rm/vehicleinfo/updateStatus`, row
        ).then((data) => {
          this.getInfo()
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              console.log('onClose')
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 新增方法
    addUpdate (row) {
      let name = 'rm-vehicleinfo-add-or-update'
      let pkName = (row != null) ? row.id : undefined
      let query = {}
      query.id = pkName
      query.operationType = row
      this.$router.push({
        name: name,
        query: query
      })
      // 广播通知执行初始化方法
      this.$eventHub.$emit(this.GLOBAL.VEHICLE_INFO, '')
    },
    // 每页数
    // sizeChangeHandle (val) {
    //   this.pageSize = val
    //   this.pageIndex = 1
    //   this.getInfo()
    // },
    pageSizeChangeHandle (val) {
      this.dataForm.page = 1
      this.dataForm.limit = val
      this.getInfo()
    },
    // 当前页
    // currentChangeHandle (val) {
    //   this.pageIndex = val
    //   this.getInfo()
    // },
    pageCurrentChangeHandle (val) {
      this.dataForm.page = val
      this.getInfo()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 车型分类调用树
    getSelectList (args) {
      // 判断返回数组是否大于0，否则前台会报错
      if (args && args !== '' && args.length > 0) {
        let vehicleArr = []
        args.forEach(function (item) {
          vehicleArr.push(item.id)
        })
        this.dataForm.vehicleClassList = vehicleArr
      } else {
        this.dataForm.vehicleClassList = []
      }
    },
    // 关闭所属场地
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    // 点击所属场地确定带回
    bringBack (selection) {
      let rowData = selection
      let siteCnName = ''
      let siteId = []
      for (var i = 0; i < rowData.length; i++) {
        siteCnName = siteCnName + rowData[i].siteCnName + ','
        siteId.push(rowData[i].id)
        // this.selectTable.push(rowData[i])
      }
      siteCnName = siteCnName.substr(0, siteCnName.length - 1)
      this.dataForm.subordinateSiteIdList = siteId
      this.dataForm.subordinateSiteName = siteCnName
      this.isShowSuboSite = false
      this.selectTable = selection
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    // 生成网格的序号
    indexCreate (index) {
      return (this.dataForm.page - 1) * this.dataForm.limit + (index + 1)
    },
    // 年度目标模板导出
    // exportAnnualTarget () {
    //   // download 参数 url, params, 报表名
    //   this.$request.download('/rm/vehicleinfo/exportAnnualTarget', this.$t('res.vehinfo.exportAnnualTarget'), {})
    // },
    exportAnnualTarget () {
      // // download 参数 url, params, 报表名
      // this.$request.download('/rm/vehicleinfo/exportAnnualTarget', this.$t('res.vehinfo.exportAnnualTarget'),
      //         {
      //           ...this.dataForm,
      //           page: this.page,
      //           limit: this.limit
      //         }
      // )
      this.$request.downloadByPost7(
              "/rm/vehicleinfo/exportAnnualTarget",
              this.$t('res.vehinfo.exportAnnualTarget') + '.xls',
              this.dataForm, null, "xls"
      )
    },
    // 车辆信息模板导出
    exportVehicleInfo () {
      // download 参数 url, params, 报表名
      this.$request.download('/rm/file/downtemplate', this.$t('res.vehinfo.ATTemplateExport'), {fileName: 'vehicle_information_template.xls'})
    },
    // 年度目标导入
    importAnnualTarget () {
      this.importDialog = true
    },
    // 车辆信息导入
    importVehicleDialog () {
      this.importVehicleInfo = true
    },
    // 关闭导入弹框
    closeDialogImport () {
      this.importDialog = false
      this.importVehicleInfo = false
    },
    // // 主页面查询按钮
    // querySiteInfo () {
    //   this.page = 1
    //   this.getDataList()
    // },
    checkLable(row){
      this.isShowLable = true
      console.info('hgjghj')
      console.info(row)
      console.info(row.id)
      console.info('qwerbcvbcbqwer')
      this.$request.get(`/rm/vehicleinfo/info/${row.id}`).then((data) => {
        console.info('qwerqwer')
        console.info(data)
        console.info('dfbfdgdg')
        // 已选择的标签
        this.checkLists = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for(let i = 0; i < this.checkLists.length; i ++){
            if(this.checkLists[i].labelNameCn !== null){
              this.checkLists[i].labelName = this.checkLists[i].labelNameCn
            }else{
              this.checkLists.splice(i,1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for(let i = 0; i < this.checkLists.length; i ++){
            if(this.checkLists[i].labelNameEn !== null){
              this.checkLists[i].labelName = this.checkLists[i].labelNameEn
            }else{
              this.checkLists.splice(i,1)
              i--
            }
          }
        }
      })
    },
    showLableClose(){
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 16
      this.bussinessTypeId = 16
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameCn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameCn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameCn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      } else {
        // this.checkList.forEach(o => {
        //   o.labelName = o.labelNameEn
        // })
        for(let i = 0; i < this.checkList.length; i ++){
          if(this.checkList[i].labelNameEn !== null){
            this.checkList[i].labelName = this.checkList[i].labelNameEn
          }else{
            this.checkList.splice(i,1)
            i--
          }
        }
      }
    },
    siteSeleteShow () {
      this.siteSeleteShowFlg = true
    },
    siteSeleteLeave () {
      this.siteSeleteShowFlg = false
    },
    siteSeleteName () {
      this.selectTable = []
      this.dataForm.subordinateSiteIdList = []
      this.dataForm.subordinateSiteName = ''
      this.siteSeleteShowFlg = false
    },

    vehicleLabelShow () {
      this.vehicleLabelShowFlg = true
    },
    vehicleLabelLeave () {
      this.vehicleLabelShowFlg = false
    },
    vehicleLabelName () {
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.vehicleLabelShowFlg = false
      console.info('this.$refs.tagTree--------->', this.$refs.tagTree)
      this.$refs.tagTree.isReset()
    }
  }
}
</script>

<style lang="css" scoped>
@import "../../css/pkg-styles.css";
</style>

<style>
  .courseclassroomrela .el-form-item__label {
    width: 120px !important;
  }
  .courseclassroomrela .el-form-item__content {
    margin-left: 120px !important;
  }
  .courseclassroomrela1>.el-form-item__content {
    margin-left: 120px !important;
  }

  .courseclassroomrela1 .el-form-item__label {
    width: 120px !important;
  }
</style>
